import qs from 'qs';

const VisitType = {
    namespaced: true,

    state: {
        visitTypeList: [],
    },

    getters: {
        visitTypeList(state) {
            return state.visitTypeList;
        },
    },

    mutations: {
        /**
         * Установить значение списка
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['visitTypeList'] = items;
        },

        // /**
        //  * Обновить элемент списка
        //  * @param state
        //  * @param item
        //  * @param index
        //  */
        // setItem (state, { item, index }) {
        //     state['visitTypeList'][index] = item;
        // },

        // /**
        //  * Добавить новый элемент в список
        //  * @param state
        //  * @param item
        //  */
        // addItem (state, { item }) {
        //     state['visitTypeList'].push(item);
        // },

        // /**
        //  * Удалить элемент из списка
        //  * @param state
        //  * @param item
        //  */
        // remove (state, { item }) {
        //     state['visitTypeList'] = state['visitTypeList'].filter(iItem => iItem !== item);
        // },
    },


    actions: {
        /**
         * Получение данных по типам визитов
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getVisitTypeList ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.visitType,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по типам визитов получены.'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN visitType.js | getVisitTypeList: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по типам визитов!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по типу визита
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        // saveVisitType ({ commit, dispatch, getters, rootGetters }, data) {
        //     return new Promise((resolve, reject) => {
        //         dispatch('loading/isLoading', true, {root:true});

        //         const str = JSON.stringify(data.data);

        //         axios({
        //             url: rootGetters.rootUrl + 'list/save',
        //             method: 'POST',
        //             headers: {
        //                 'content-type': 'application/x-www-form-urlencoded'
        //             },
        //             data: qs.stringify({
        //                 'data': str,
        //                 'token': this.getters['auth/getToken'],
        //                 'service': rootGetters.service.visitType,
        //             }),
        //         }).then(response => {
        //             // Если редактирование
        //             if (data.index !== -1) {
        //                 commit('setItem', {
        //                     item: data.data,
        //                     index: data.index
        //                 });
        //                 dispatch('loading/isLoading', false, {root:true});
        //                 window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Тип визита успешно отредактирован!');
        //             // Если сохранение нового
        //             } else {
        //                 data.data.id = response.data[0].id;

        //                 commit('addItem', {
        //                     item: data.data
        //                 });
        //                 dispatch('loading/isLoading', false, {root:true});
        //                 window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый тип визита успешно создан!');
        //             }
        //             resolve();
        //         }).catch(err => {
        //             dispatch('loading/isLoading', false, {root:true});
        //             window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
        //             console.log('ERROR IN visitType.js | saveVisitType: ' + err);
        //             reject(err);
        //         })
        //     })
        // },

        /**
         * Удаление типа визита
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        // removeVisitType ({ commit, dispatch, getters, rootGetters }, data) {
        //     return new Promise((resolve, reject) => {
        //         dispatch('loading/isLoading', true, {root:true});
        //         const str = JSON.stringify(data.item);
        //         axios({
        //             url: rootGetters.rootUrl + 'list/delete',
        //             method: 'POST',
        //             headers: {
        //                 'content-type': 'application/x-www-form-urlencoded'
        //             },
        //             data: qs.stringify({
        //                 'data': str,
        //                 'token': this.getters['auth/getToken'],
        //                 'service': rootGetters.service.visitType,
        //             }),
        //         }).then(response => (
        //             commit('remove', {
        //                 item: data.item
        //             }),
        //             dispatch('loading/isLoading', false, {root:true}),
        //             window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Тип визита успешно удален!'),
        //             resolve()
        //         )).catch(err => {
        //             dispatch('loading/isLoading', false, {root:true});
        //             window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении данных!'),
        //             console.log('ERROR IN visitType.js | removeVisitType: ' + err);
        //             reject(err);
        //         });
        //     })
        // },
    },
};

export default VisitType;


// WEBPACK FOOTER //
// ./src/store/modules/visitType.js